import { useState } from "react";
import {
  disableRequestMock,
  enableRequestMock,
  getRequestedMocks,
} from "src/utils/browserRequestMocks";
import Cookies from "js-cookie";
import { Button, Checkbox } from "react-aria-components";
import ChevronDown from "src/design-system/icons/ChevronDown.svg?react";
import ChevronUp from "src/design-system/icons/ChevronUp.svg?react";

export default function MockFlagSelector() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const activeMocks = getRequestedMocks();

  if (import.meta.env.VITE_MOCK_SERVICE_WORKER_ENABLED !== "true") {
    return null;
  }

  return (
    <>
      <Button
        className="flex w-full cursor-pointer items-center justify-between p-4 text-left text-sm 2xl:w-100"
        onPress={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <div>
          <h3>Request Mock Flags</h3>
          <p>Intercept API requests in-browser.</p>
        </div>
        {!isDropdownOpen ? <ChevronDown /> : <ChevronUp />}
      </Button>
      {isDropdownOpen && (
        <ul className="flex w-full flex-col gap-3 p-4 text-sm 2xl:w-100">
          <li className="flex justify-between">
            <label htmlFor="auth">Authentication (reloads window)</label>
            <Checkbox
              className="flex h-4.5 w-4.5 cursor-pointer items-center justify-center border-1 border-input-border"
              id="auth"
              isSelected={activeMocks.includes("auth")}
              onChange={() => {
                if (activeMocks.includes("auth")) {
                  Cookies.remove("r2r_session");
                  disableRequestMock("auth");
                } else {
                  Cookies.set("r2r_session", "mocked");
                  enableRequestMock("auth");
                }
              }}
            />
          </li>
          <li className="flex justify-between">
            <label htmlFor="trip">Trips (reloads window)</label>
            <Checkbox
              className="flex h-4.5 w-4.5 cursor-pointer items-center justify-center border-1 border-input-border"
              id="trip"
              isSelected={activeMocks.includes("trip")}
              onChange={() => {
                if (activeMocks.includes("trip")) {
                  disableRequestMock("trip");
                } else {
                  enableRequestMock("trip");
                }
              }}
            />
          </li>
        </ul>
      )}
    </>
  );
}
